module.exports = __webpack_public_path__ + "static/media/dev.8811534c.png";